import React from "react";
import "./Modal.css";

/**
 * Generic modal.
 * - variant: "confirm" | "info" (default: "confirm")
 * - confirmLabel: label for the confirm button (default: "Confirm")
 * - onConfirm: only shown when provided AND variant === "confirm"
 *
 * If responseMessage is present, only a single "Close" button is shown.
 */
function Modal({
  isOpen,
  title,
  message,
  onClose,
  onConfirm,
  isProcessing,
  responseMessage,
  variant = "confirm",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}) {
  if (!isOpen) return null;

  const showConfirmRow =
    !responseMessage && variant === "confirm" && typeof onConfirm === "function";

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h3>{title}</h3>
          <button className="modal-close-btn" onClick={onClose} aria-label="Close">
            &times;
          </button>
        </div>

        <div className="modal-body">
          {message && <p>{message}</p>}

          {responseMessage && (
            <div className={`response-message ${responseMessage.type}`}>
              {responseMessage.text}
            </div>
          )}
        </div>

        <div className="modal-footer">
          {showConfirmRow ? (
            <>
              <button
                className="btn secondary-btn"
                onClick={onClose}
                disabled={isProcessing}
              >
                {cancelLabel}
              </button>
              <button
                className="btn danger-btn"
                onClick={onConfirm}
                disabled={isProcessing}
              >
                {isProcessing ? "Processing..." : confirmLabel}
              </button>
            </>
          ) : (
            <button className="btn primary-btn" onClick={onClose}>
              Close
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Modal;